export * from "./subject.component";
